
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopandharpurcab() {



    const cardData =
    {
        keyword: ' Mumbai to pandharpur cab',
        heading: 'Skyline Cabs:  Mumbai to pandharpur cab',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Mumbai to Pandharpur Cab services for a peaceful and spiritual journey. Whether you are traveling for a pilgrimage to the famous Vithoba temple or exploring the cultural richness of Pandharpur, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride.​',

        top: 'Top Places to Visit in pandharpur with Skyline Cabs',

"topPlaces": [
    {
        "title": "Vithoba Temple",
        "description": "The Vithoba Temple is the most prominent religious site in Pandharpur, dedicated to Lord Vithoba (a form of Lord Vishnu). This temple is a major pilgrimage destination for devotees from all over India, especially during the annual Ashadi Ekadashi festival."
    },
    {
        "title": "Chandrabhan Lake",
        "description": "A serene lake located near the Vithoba Temple, Chandrabhan Lake is a peaceful spot for visitors to relax. It is often associated with religious rituals and offers a calm atmosphere with scenic views."
    },
    {
        "title": "Bhima River",
        "description": "The Bhima River flows near Pandharpur and holds significant religious importance. Pilgrims often take a holy dip in the river before visiting the Vithoba Temple, believing it to cleanse their sins."
    },
    {
        "title": "Pandharpur Fort",
        "description": "A historic fort located near the town, Pandharpur Fort offers panoramic views of the surroundings. While not a major tourist destination, it’s a place where visitors can explore the region’s history and heritage."
    },
    {
        "title": "Akkalkot Swami Samarth Maharaj Temple",
        "description": "Located about 40 km from Pandharpur, Akkalkot is the site of the temple dedicated to the revered saint Swami Samarth Maharaj. This temple attracts many devotees, particularly those seeking spiritual solace."
    },
    {
        "title": "Shree Vitthal Rakhumai Temple",
        "description": "This temple is dedicated to Lord Vithoba and his consort Rakhumai. It is another important site for pilgrims visiting Pandharpur and is known for its tranquil setting and historical significance."
    },
    {
        "title": "Vithal-Rakhumai Mandir",
        "description": "Located in the heart of Pandharpur, this temple is dedicated to Lord Vithoba and his consort, Rakhumai. It is a major religious and cultural landmark, visited by thousands of devotees throughout the year."
    },
    {
        "title": "Yamunabai Temple",
        "description": "This temple is dedicated to Goddess Yamunabai, the sister of Lord Vithoba. It holds religious importance, especially for local devotees, and adds to the spiritual atmosphere of Pandharpur."
    },
    {
        "title": "Tulja Bhavani Temple",
        "description": "Located around 50 km from Pandharpur, the Tulja Bhavani Temple is dedicated to Goddess Bhavani. It is a significant religious site for those seeking blessings from the goddess, known for its unique architecture and serene environment."
    },
    {
        "title": "Wai",
        "description": "Located near Pandharpur, Wai is known for its ancient temples and scenic beauty. A visit to Wai provides an opportunity to explore the region’s culture and natural surroundings, making it an ideal spot for a day trip."
    }
],

"services": [
    {
      "name": "Mumbai to Pandharpur Cab",
      "description": "Skyline Cabs offers comfortable and reliable cab services from Mumbai to Pandharpur. Travel in comfort and ease with our experienced drivers for your journey."
    },
    {
      "name": "Pandharpur Taxi from Mumbai",
      "description": "Book a taxi from Mumbai to Pandharpur with Skyline Cabs. We ensure a smooth and timely ride with professional drivers for your convenience."
    },
    {
      "name": "Mumbai to Pandharpur One Way Cab",
      "description": "Rent a one-way cab from Mumbai to Pandharpur with Skyline Cabs. Perfect for travelers who need a direct journey without the hassle of a round trip."
    },
    {
      "name": "Pandharpur Darshan Taxi from Mumbai",
      "description": "Skyline Cabs provides a comfortable taxi service from Mumbai to Pandharpur for darshan trips. Travel with ease and reach your destination with peace of mind."
    },
    {
      "name": "Mumbai to Pandharpur Cab Booking",
      "description": "Book a cab from Mumbai to Pandharpur easily with Skyline Cabs. Enjoy flexible booking options, reliable service, and a comfortable ride."
    }
  ],
  "tableData": [
    ["Mumbai to Pandharpur Cab", "Pandharpur Taxi from Mumbai"],
    ["Mumbai to Pandharpur One Way Cab", "Pandharpur Darshan Taxi from Mumbai"],
    ["Mumbai to Pandharpur Cab Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai to Pandharpur Cab Service",
      "WhyChoosedescription": "Book a comfortable cab from Mumbai to Pandharpur for a smooth and spiritual journey. Whether you're visiting for pilgrimage or leisure, we ensure a peaceful and reliable travel experience."
    },
    {
      "WhyChooseheading": "Comfortable and Pilgrimage-Ready Cabs",
      "WhyChoosedescription": "Our cabs are perfect for long journeys, offering comfortable seating, air conditioning, and a smooth ride—ideal for your trip to the sacred town of Pandharpur."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy competitive and clear pricing with no hidden costs. We offer affordable cab services from Mumbai to Pandharpur with straightforward fare details."
    },
    {
      "WhyChooseheading": "Experienced and Polite Drivers",
      "WhyChoosedescription": "Our drivers are courteous and experienced with pilgrimage routes, ensuring safe driving and respectful service throughout your trip."
    },
    {
      "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel worry-free in clean, sanitized, and regularly maintained cabs, designed to offer you a hygienic and comfortable journey."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Choose from one-way, round trip, or extended stay options depending on your visit plans to Pandharpur. We offer flexible packages tailored to your needs."
    },
    {
      "WhyChooseheading": "Perfect for Pilgrimage, Family Travel, or Solo Trips",
      "WhyChoosedescription": "Whether you’re traveling with family, friends, or alone, our cab service provides a reliable and convenient option for reaching Pandharpur."
    },
    {
      "WhyChooseheading": "24/7 Customer Support and Easy Booking",
      "WhyChoosedescription": "Book your cab online or over the phone anytime. Our 24/7 customer support ensures a hassle-free booking experience with help available whenever you need it."
    }
  ]
  
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Pandharpur with Skyline Cabs?',
            answer:
                'You can easily book a cab from Mumbai to Pandharpur through our website, mobile app, or by calling our customer care team. Just provide your pickup point, destination, date of travel, and vehicle preference to confirm the booking.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Pandharpur?',
            answer:
                'The distance from Mumbai to Pandharpur is approximately 380 km. The travel time typically ranges from 7 to 9 hours, depending on the traffic and road conditions.',
        },
        {
            id: 3,
            question: 'What vehicle options are available for this route?',
            answer:
                'Skyline Cabs offers a variety of vehicles for the Mumbai to Pandharpur trip, including Swift Dzire, Ertiga, Kia Carens, Innova Crysta, and SUVs. For group travel or pilgrims, we also provide Tempo Travellers and minibuses.',
        },
        {
            id: 4,
            question: 'Are your Mumbai to Pandharpur cab fares fixed?',
            answer:
                'Yes, our fares are fixed and transparent. The price includes fuel, driver allowance, tolls, and taxes. You’ll receive a detailed fare breakdown before confirming the booking—no hidden charges.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab to Pandharpur?',
            answer:
                'Yes, you can choose either a one-way or round-trip cab based on your travel plan. One-way cab bookings are ideal for those not planning to return the same day.',
        },
        {
            id: 6,
            question: 'Is it safe to travel to Pandharpur by cab?',
            answer:
                'Absolutely. Skyline Cabs prioritizes your safety. Our vehicles are regularly maintained and sanitized, and our drivers are experienced in long-distance travel and familiar with religious routes.',
        },
        {
            id: 7,
            question: 'Can we take a break or visit temples en route?',
            answer:
                'Yes, we allow short stopovers during the journey. You can take breaks for meals, rest, or even visit temples or spiritual spots on the way. Let the driver know in advance.',
        },
        {
            id: 8,
            question: 'What payment methods are accepted?',
            answer:
                'We accept UPI, credit/debit cards, net banking, and cash payments after the ride. Online payments are secured via trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my booking?',
            answer:
                'Yes, you can easily cancel or modify your booking via our app, website, or by contacting our customer support. Flexible cancellation policies are available for your convenience.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Mumbai to Pandharpur travel?',
            answer:
                'Skyline Cabs offers comfortable, safe, and reliable transportation to Pandharpur. With experienced drivers, clean and well-maintained vehicles, and transparent pricing, your pilgrimage or trip will be smooth and stress-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ganesh Jadhav",
            rating: 5,
            review: "Travelled from Mumbai to Pandharpur for darshan. The cab was clean, the driver was respectful and knowledgeable about the route. A very peaceful and pleasant experience!"
        },
        {
            name: "Mrs. Lata Deshpande",
            rating: 4,
            review: "Skyline Cabs made our journey to Pandharpur smooth and timely. Great for family travel. Just wished the driver had a bit more local knowledge about nearby attractions."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pandharpur Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-pandharpur-cab.jpg",
  "description": "Book Mumbai to Pandharpur cab with Skyline Cabs for a comfortable and devotional journey. Choose from AC sedans, SUVs, or luxury vehicles with verified drivers, 24/7 availability, and fixed fare pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7812"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5199",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-pandharpur-cab"
  }
};


      
     
      

    return (
        <div>
<Helmet>
  <title>Mumbai to Pandharpur Cab | Darshan Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pandharpur cab with Skyline Cabs for a comfortable and devotional journey. Choose from AC sedans, SUVs, or luxury vehicles with verified drivers, 24/7 availability, and fixed fare pricing." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pandharpur Cab, Cab for Pandharpur Darshan, AC Taxi Mumbai to Pandharpur, SUV Hire Mumbai to Pandharpur, One Way Cab Mumbai Pandharpur, Skyline Cabs Booking, Mumbai to Pandharpur Trip, 24/7 Cab to Pandharpur, Affordable Taxi Mumbai Pandharpur, Luxury Car Hire for Pandharpur Yatra" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/104.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopandharpurcab;